import React from 'react';

const TreeIcon = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.6 10.3V8.2C2.6 8.01435 2.67375 7.8363 2.80503 7.70503C2.9363 7.57375 3.11435 7.5 3.3 7.5H11.7C11.8857 7.5 12.0637 7.57375 12.195 7.70503C12.3263 7.8363 12.4 8.01435 12.4 8.2V10.3M7.5 7.5V4.7M11 10.3H13.8C14.1866 10.3 14.5 10.6134 14.5 11V13.8C14.5 14.1866 14.1866 14.5 13.8 14.5H11C10.6134 14.5 10.3 14.1866 10.3 13.8V11C10.3 10.6134 10.6134 10.3 11 10.3ZM1.2 10.3H4C4.3866 10.3 4.7 10.6134 4.7 11V13.8C4.7 14.1866 4.3866 14.5 4 14.5H1.2C0.813401 14.5 0.5 14.1866 0.5 13.8V11C0.5 10.6134 0.813401 10.3 1.2 10.3ZM6.1 0.5H8.9C9.2866 0.5 9.6 0.813401 9.6 1.2V4C9.6 4.3866 9.2866 4.7 8.9 4.7H6.1C5.7134 4.7 5.4 4.3866 5.4 4V1.2C5.4 0.813401 5.7134 0.5 6.1 0.5Z"
      stroke="#007AAE"
      stroke-opacity="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default TreeIcon;
